import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Plan statuses considered "active access" — anything else routes to billing-required.
const ACTIVE_PLAN_STATUSES = ['active', 'trialing'];

export default function ProtectedRoute({ children, allowedRoles }) {
  const { isAuthenticated, role, onboardingComplete, loading, planStatus, suspended } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to='/login' replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to='/login' replace />;
  }

  // Plan gating — block access if subscription isn't active.
  // Org admins still get through to the billing page so they can fix it.
  // null planStatus is treated as a fatal config issue, not free access.
  if (suspended || !planStatus || !ACTIVE_PLAN_STATUSES.includes(planStatus)) {
    return <Navigate to='/billing-required' replace />;
  }

  if (!onboardingComplete && !location.pathname.startsWith('/onboarding')) {
    if (role === 'org_admin') return <Navigate to='/onboarding/admin' replace />;
    if (role === 'manager') return <Navigate to='/onboarding/manager' replace />;
    if (role === 'operator') return <Navigate to='/onboarding/operator' replace />;
  }

  return children;
}